import { useMemo, type JSX } from 'react';
import { useProject, useRuntime, useStudio } from '../../context';
import { audioSourceIds, liveAudioKey, sourceKindsKey } from './audioSources';
import { Strip } from './Strip';
import '../panels.css';

export function useAudioSourceIds(): string[] {
  const studio = useStudio();
  const kinds = useProject(sourceKindsKey);
  const live = useRuntime(liveAudioKey);
  return useMemo(() => audioSourceIds(kinds, live, studio.registry), [kinds, live, studio]);
}

export function MixerPanel(): JSX.Element {
  const ids = useAudioSourceIds();
  return (
    <div className="mixer" role="group" aria-label="Audio mixer">
      {ids.map((id) => (
        <Strip key={id} sourceId={id} />
      ))}
      {ids.length === 0 ? <div className="ui-empty ui-grow">Sources with audio appear here.</div> : null}
      <Strip sourceId={null} />
    </div>
  );
}
